<template>
    <div class="field datepicker" :class="{ 'required': required }">
        <div class="heading">
            <label>{{ label }}</label>
        </div>
        <div class="input">
            <datepicker
                :value="formattedDate"
                :placeholder="placeholder"
                format="dd/MM/yyyy"
                v-bind="datepickerOptions"
                @selected="updateDate"
            />
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
    components: {
        Datepicker
    },

    props: {
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: null,
        },
        datepickerOptions: {
            type: Object,
            default: () => {
                return {
                    disabledDates: {
                        // Yesterday
                        to: ((d) => new Date(d.setDate(d.getDate()-1)) )(new Date)
                    }
                }
            },
        },
    },

    computed: {
        formattedDate() {
            return this.value ? moment(this.value, 'DD/MM/YYYY').toDate() : null;
        }
    },

    methods: {
        updateDate(value) {
            const date = moment(value).format('DD/MM/YYYY');
            this.$emit('input', date);
        }
    }
};
</script>
